/**
 * Загрузка внешнего скрипта по требованию.
 *
 * Идемпотентна: повторный вызов не вставляет второй <script>, а параллельные вызовы
 * ждут один и тот же промис. Нужна платёжному виджету, который живёт на CDN провайдера
 * и не должен подтягиваться на сборках без платного контура.
 */

const cache = new Map<string, Promise<void>>()

export function loadScript(src: string): Promise<void> {
	const cached = cache.get(src)
	if (cached) return cached

	const promise = new Promise<void>((resolve, reject) => {
		const existing = document.querySelector<HTMLScriptElement>(`script[src="${src}"]`)
		if (existing) {
			existing.addEventListener('load', () => resolve())
			existing.addEventListener('error', () => reject(new Error(`Не удалось загрузить скрипт: ${src}`)))
			// Скрипт мог загрузиться до того, как мы подписались: события уже не будет.
			if (existing.dataset.loaded === 'true') resolve()
			return
		}

		const script = document.createElement('script')
		script.src = src
		script.async = true
		script.addEventListener('load', () => {
			script.dataset.loaded = 'true'
			resolve()
		})
		script.addEventListener('error', () => reject(new Error(`Не удалось загрузить скрипт: ${src}`)))
		document.head.appendChild(script)
	})

	// Провал кешировать нельзя: вторая попытка должна быть возможна.
	promise.catch(() => cache.delete(src))
	cache.set(src, promise)
	return promise
}

/** Только для тестов: сбрасывает кеш промисов между кейсами. */
export function resetScriptCache(): void {
	cache.clear()
}
